var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9619 6.21845L13.0294 6.28595C13.3219 6.57845 13.3219 7.05095 13.0294 7.34345L8.84437 11.5359C8.55187 11.8284 8.07937 11.8284 7.78687 11.5359L5.46937 9.21845C5.17688 8.92595 5.17688 8.45345 5.46937 8.16095L5.53687 8.09345C5.82937 7.80095 6.30187 7.80095 6.59437 8.09345L8.31937 9.81845L11.9044 6.22595C12.1894 5.92595 12.6694 5.92595 12.9619 6.21845Z",
    fill: "#1CA349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.975e5832729ee1a88ebc8b700112341e.svg";
export { ForwardRef as ReactComponent };